<template>
    <component :is="layout" ref="layout"/>
</template>

<script>
import store from "@/store"
import { $session } from "@/plugin/dot-framework-vue-1.0.8"
import {$config, COMP_CODE, getAppDocumentTitle, applyFavicon} from "@/tenant/config";
import '@/asset/css/font.css';
import FontFaceObserver from 'fontfaceobserver';

function loadGlobalStyles() {
    if (COMP_CODE === 'GOOGLE') {
        require('@/tenant/GOOGLE/asset/css/global.scss');
    } else {
        require('@/asset/css/global.scss');
    }
}
loadGlobalStyles()

const Locales = require("@/asset/data/locales.json")

export default {
    name: 'App',
    provide() {
        return {
            dotFilter: this.$filter,
            dotMixins: this.$mixins
        }
    },
    data() {
        return {
            layout: null,
            convertCheckInterval: null,
        }
    },
    created() {
        if (COMP_CODE === 'GOOGLE') {
            document.documentElement.classList.add('tenant-google');
        }
        document.title = getAppDocumentTitle();
        applyFavicon();
        this.setFont()
        this.setHTMLLangAttribute()
        this.initLocale()
    },
    beforeMount() {
        document.getElementById("spinner").classList.add('d-none')
    },
    watch: {
        $route(to) {
            // ---------------------------------
            // 멀티 테넌트 레이아웃 설정
            // ---------------------------------
            const name = to?.meta?.layout || "DefaultLayout";
            this.layout = $config.getLayout(name);

            if (this.$store.getters["auth/isAuthenticated"]) {
                // 이미 설정된 인터벌이 있으면 클리어
                if (this.convertCheckInterval) {
                    clearInterval(this.convertCheckInterval);
                }
                // 새로운 인터벌 설정
                this.convertCheckInterval = setInterval(() => {
                    if (this.checkPageVisibility()) {
                        this.loadAndShowPopups();
                    }
                }, 30000); // 30000 milliseconds = 30 seconds
            } else {
                if (this.convertCheckInterval) {
                    clearInterval(this.convertCheckInterval);
                }
            }
        },
        '$store.getters["auth/isAuthenticated"]'(isAuthenticated) {
            if (!isAuthenticated) {
                if (this.convertCheckInterval) {
                    clearInterval(this.convertCheckInterval);
                    this.convertCheckInterval = null;
                }
            }
        },
        '$i18n.locale'() {
            this.setHTMLLangAttribute();
            // this.setHTMLDirAttribute();
        },
    },
    beforeDestroy() {
        // 컴포넌트가 파괴되기 전에 인터벌 클리어
        if (this.convertCheckInterval) {
            clearInterval(this.convertCheckInterval)
        }
    },
    methods: {
        setHTMLDirAttribute() {
            document.documentElement.setAttribute('dir', this.$i18n.locale === 'ar' ? 'rtl' : 'auto')
        },
        /**
         * 다국어 설정
         */
        setHTMLLangAttribute() {
            document.documentElement.setAttribute('lang', this.$i18n.locale)
        },
        initLocale() {
            const defaultLanguage = "en"
            const settingLang = localStorage.getItem("_LANGUAGE_")
            if (settingLang) {
                return this.$i18n.locale = settingLang
            }
            else {
                const lang = navigator.language || navigator.userLanguage
                const code = lang.substring(0, 2)
                const availableLocales = this.$i18n.availableLocales.includes(code)
                const locale = availableLocales && Locales.some(e => e.code === code) ? code : defaultLanguage
                localStorage.setItem("_LANGUAGE_", locale)

                return this.$i18n.locale = locale
            }
        },
        /**
         * 폰트 설정
         * @see https://fonts.google.com/knowledge/glossary/fout
         */
        setFont() {
            const font = new FontFaceObserver('Helvetica Neue')

            font.load().then(function () {
                document.body.classList.add("fonts-loaded");
            }).catch(function () {
                console.log('Helvetica Neue failed to load.');
            })
        },

        async loadAndShowPopups() {
            try {
                const popupList = await store.dispatch("textbook/getConversionCompletePopup", $session.getUserNo())
                let message = ""

                if (popupList && popupList.length > 0) {
                    for (const popup of popupList) {
                        await store.dispatch("textbook/popupDisplayComplete", popup.DTM_NO)
                        if (popup.STATUS === "FAILED") {
                            message = this.$t('HTML 변환에 실패하였습니다.')
                        } else {
                            message = this.$t('HTML 변환이 완료되었습니다.')
                        }
                    }

                    this.showPopup(message);
                }
            } catch (error) {
                console.error("Failed to load and show popups:", error)
            }
        },
        showPopup(message) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
            });

            Toast.fire({
                html: `<swalCustomTag style="color: black;"><b>${message}</b></swalCustomTag>`,
            });
        },
        checkPageVisibility() {
            return document.visibilityState === "visible"
        }
    }
}
</script>

<style scoped>
</style>
